import ImageProcessor from './ImageProcessor'
import { ImageMagick, initializeImageMagick } from '@imagemagick/magick-wasm'

class ImageMagickProcessor extends ImageProcessor {
  constructor (onProcessingComplete, onProcessingError) {
    super()
    this.onProcessingComplete = onProcessingComplete
    this.onProcessingError = onProcessingError
    this.initialized = this.init()
  }

  async init () {
    // initialize module w/ wasm
    const magickWasmURL = new URL('../../../node_modules/@imagemagick/magick-wasm/dist/magick.wasm', import.meta.url)
    await initializeImageMagick(magickWasmURL)
  }

  async process (file, counter) {
    try {
      await this.initialized
      const buffer = await file.arrayBuffer()
      const array = new Uint8Array(buffer)
      await ImageMagick.read(array, async (image) => {
        // down-size image (can be updated accordingly)
        image.resize(this.MAX_THUMBNAIL_WIDTH, this.MAX_THUMBNAIL_HEIGHT)

        // we don't have access to DOM, so we create an OffscreenCanvas
        const canvas = new OffscreenCanvas(image.width, image.height)

        // write image data onto canvas
        image.writeToCanvas(canvas)

        // Get canvas blob and read as a dataUrl
        const blob = await canvas.convertToBlob()
        // This image reader will convert the blob to a string that can be directly inserted to the thumbnail element
        const imageReader = new FileReader()
        imageReader.addEventListener('load', (event) => this.onProcessingComplete(this, { data: event.target.result, id: counter }))
        imageReader.addEventListener('error', (event) => this.onProcessingError(this, event))
        imageReader.readAsDataURL(blob)
      })
    } catch (error) {
      this.onProcessingError(this, new Error(`ImageMagickProcessor Error: ${error.message}:`))
    }
  }
}

export default ImageMagickProcessor
